import React, { useEffect, useState } from 'react';
import { getToken } from '../utils/cookieUtils';
import LoggedNav from "../components/LoggedNav";
import Nav from "../components/Nav";
import SubscriptionPlans from "../components/SubscriptionPlans"; // Assuming this is the correct import for the SubscriptionPlans component

function SubscriptionPage(props) {
  return (
    <>
      {getToken() ? <LoggedNav customer={props.customer} /> : <Nav customer={props.customer} />}
 
      <SubscriptionPlans /> {/* Render the SubscriptionPlans component */}
    </>
  );
}

export default SubscriptionPage;